import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchInterceptors } from "../../Api/fetchInterceptors";

const END_POINT_GENERATE_API_KEY =
  process.env.REACT_APP_END_POINT_GENERATE_API_KEY;

export const change_ApiKey = createAsyncThunk(
  "generate/api/key",
  async (patchData, thunkApi) => {
    try {
      const result = fetchInterceptors(
        END_POINT_GENERATE_API_KEY,
        "POST",
        patchData
      );
      return result;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const change_ApiKey_Slice = createSlice({
  name: "changeApiKey",
  initialState: {
    response: null,
    success: false,
    statusCode: null,
    error: null,
    loading: null,
  },
  reducers: {
    setDefault_Change_Api_Key: (state) => {
      state.response = null;
      state.success = false;
      state.statusCode = null;
      state.error = null;
      state.loading = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(change_ApiKey.pending, (state) => {
        state.loading = true;
      })
      .addCase(change_ApiKey.fulfilled, (state, action) => {
        if (action.payload?.success) {
          state.error = null;
          state.response = action.payload;
          state.success = action.payload?.success;
          state.statusCode = action.payload?.code;
          state.loading = false;
        } else {
          state.response = null;
          state.error = action.payload;
          state.success = action.payload?.success;
          state.statusCode = action.payload?.code;
          state.loading = false;
        }
      })
      .addCase(change_ApiKey.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setDefault_Change_Api_Key } = change_ApiKey_Slice.actions;
export default change_ApiKey_Slice.reducer;
